import api from "lib/axios";

const BASE_URL = 'api';

const evaluationClient = {
    getEvaluationCriteria: eventId => api.get(`${BASE_URL}/get_evaluation_criteria/${eventId}/`),
    getEvaluationSheet: uuidStr => api.get(`${BASE_URL}/get_evaluation_sheet/${uuidStr}/`),
    sendEvaluationGrades: (uuidStr, projectId, evaluationGrades) => api.post(`${BASE_URL}/receive_evaluation_grades/${uuidStr}/${projectId}/`, evaluationGrades),
    getSheetGrades: uuidStr => api.get(`${BASE_URL}/get_finalized_sheet/${uuidStr}/`),
    getEvaluatorSheets: (eventId, evaluatorUuid) => api.get(`${BASE_URL}/get_evaluator_sheets/${eventId}/${evaluatorUuid}/`)
}

export default evaluationClient;
